// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2nrCX","colMin":"styles_colMin__3urVx"};